<template>
	<div class="login-wrapper">
		<ja-header title="login" subtitle="JA Finance Park" :disable-logout="true">
			<template v-slot:icon>
				<svgicon name="headerIcons/login"></svgicon>
			</template>
		</ja-header>
		<content>
			<h1>{{ $t('loginMsg') }}</h1>
			<img class="login-image" src="../assets/images/door.png" alt="" />
			<form class="user-information" autocomplete="off">
				<ja-input
					v-model.trim="pin"
					class="form-control middle"
					:label="'account number'"
					:name="pin"
					:is-number-input="true"
					@input="updateFormData"
				></ja-input>
				<ja-input
					v-model.trim="code"
					class="form-control middle"
					:label="'pin'"
					:name="code"
					:is-number-input="true"
					@input="updateFormData"
				></ja-input>
				<div v-show="codeIncorrect" class="text--small text--danger">
					{{ $t('codeIncorrect') }}
				</div>
			</form>
			<ja-button
				class="login-btn large"
				name="login"
				:aria-label="$t('login')"
				@click.native="internalLogin"
				>{{ $t('login') }}</ja-button
			>
			<ja-button
				class="login-btn large altcolor"
				name="login"
				:aria-label="$t('login')"
				@click.native.once="externalLogin"
				>Standard {{ $t('login') }}</ja-button
			>
			<ja-national-sponsor
				:external-sim-type="simulationType"
			></ja-national-sponsor>
		</content>
		<footer v-if="!cookiesAccepted">
			<div class="text-cookies">
				{{ $t('splashscreenTextCookies') }}
				<a
					href="https://www.juniorachievement.org/web/ja-usa/privacy-policy"
					target="_blank"
					rel="noopener"
					>{{ $t('splashscreenPrivacyPolicy') }}</a
				>
				{{ $t('splashscreenAnd') }}
				<a
					href="https://www.juniorachievement.org/web/ja-usa/website-terms-and-conditions"
					target="_blank"
					rel="noopener"
					>{{ $t('splashscreenTermsAndConditions') }}</a
				>
				.
			</div>
			<ja-button
				class="small outlined"
				name="cookies"
				@click.native="hideFooter"
				>{{ $t('splashscreenUnderstand') }}</ja-button
			>
		</footer>
	</div>
</template>
<script>
import '../components/icons/headerIcons/login';
import Button from '../components/ui/Button';
import Header from '../components/ui/headers/Header';
import NationalSponsor from '../components/ui/NationalSponsor';
import { Input } from '@/components/ui/form';

export default {
	components: {
		jaButton: Button,
		jaHeader: Header,
		jaNationalSponsor: NationalSponsor,
		jaInput: Input
	},
	props: {
		simulationType: {
			type: String,
			default: 'AdvancedVirtual'
		}
	},
	data() {
		return {
			cookiesAccepted: localStorage.getItem('cookieStatus'),
			pin: '',
			code: '',
			codeIncorrect: false
		};
	},
	mounted() {
		this.$store.commit('setLoading', false);
	},
	methods: {
		internalLogin() {
			if (this.code !== '9' + this.pin) {
				this.codeIncorrect = true;
			} else {
				this.codeIncorrect = false;
				this.$store.commit('setLoading', true);
				localStorage.setItem('jaSimType', this.simulationType);
				localStorage.setItem('loginPin', this.pin);
				this.$store.dispatch('internalauth');
			}
		},
		externalLogin() {
			this.$store.commit('setLoading', true);
			localStorage.setItem('jaSimType', this.simulationType);
			this.$store.dispatch('auth');
		},
		hideFooter() {
			localStorage.setItem('cookieStatus', true);
			this.cookiesAccepted = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.login-wrapper {
	font-family: 'RobotoRegular';
	height: 100%;
	display: flex;
	flex-direction: column;

	.text {
		&--small {
			font-size: 12px;
			vertical-align: middle;
			line-height: 24px;
		}

		&--danger {
			color: $font-red-alert;
		}
	}

	content {
		display: flex;
		flex-direction: column;
		align-items: center;
		// justify-content: center;
		flex-grow: 1;

		h1 {
			margin-top: 32px;
			margin-bottom: 24px;

			@media (min-width: $breakpoint-mid) {
				margin-top: 64px;
				margin-bottom: 32px;
			}
		}

		.middle {
			width: 200px;
		}

		.login-btn {
			margin-top: 24px;
			margin-bottom: 24px;

			@media (min-width: $breakpoint-mid) {
				margin-top: 32px;
				margin-bottom: 32px;
			}
		}

		.altcolor {
			color: #fff;
			background-color: #999;
			margin-top: 0px;
		}

		.body-text-2 {
			margin-bottom: 16px;
		}

		.login-image {
			@media (max-height: 800px) {
				height: 180px;
			}
		}
	}

	footer {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: $page-bgcolor;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		padding: 0px 5%;

		.text-cookies {
			height: auto;
			width: 75%;
			color: $disabled-text-color;
			font-family: 'RobotoRegular';
			font-size: 14px;
			letter-spacing: 0.25px;
			line-height: 21px;
			margin-top: 16px;
			margin-bottom: 16px;
			margin-right: 5%;

			@media (min-width: $breakpoint-mid) {
				margin-bottom: 32px;
			}
		}
	}
}
</style>
